import { getVertexId } from '../../core/util';
import type { CoreTypes } from '../../core';
import type { Types as SduiTypes } from '../types';

export default (
  course:  CoreTypes.Mixed.Course,
  options: SduiTypes.options
): SduiTypes.course => {
  return {
    id:       getVertexId(course, options),
    name:     course.displayName,
    color:    course.color,
    teachers: (course.teachers ?? []).map(x => getVertexId(x.to, options)),
    classes:  (course.groups   ?? []).map(x => getVertexId(x.to, options)),
  };
};